import makeStyles from '@ui/utils/makeStyles';

export default makeStyles()((theme) => ({
  appEnvironmentNotice: {
    background: theme.palette.warning.main,
    color: theme.palette.warning.contrastText,
    position: 'fixed',
    bottom: 0,
    right: 0,
    padding: theme.spacing(1, 1),
    borderTopLeftRadius: theme.shape.borderRadius,
    fontSize: 10,
  }
}));
